import React from 'react'
import { Box, Checkbox, Clickable, Icon } from '@maui/elements'
import { useController } from 'react-hook-form'
import { useDraft } from '@maui/hooks'

export const FormNestedCheckbox = ({ control, options }) => {
  const [expanded, setExpanded] = React.useState(false)

  const values = options.map((item) => item.value)

  const { field } = useController({
    control,
    name: 'vulnRiskRating'
  })
  const { field: parentField } = useController({
    control,
    name: 'intelPackages',
  })

  const [parentValue] = useDraft(parentField.value)
  const [items] = useDraft(field.value)

  const handleParentChecked = (e) => {
    const valueCopy = [...new Set(parentValue)]

    if (e.target.checked) {
      valueCopy.push(e.target.value)
      field.onChange(values)
    } else {
      const index = valueCopy.indexOf(e.target.value)
      if (index > -1) {
        valueCopy.splice(index, 1)
      }
      field.onChange([])
    }
    // send data to react hook form
    parentField.onChange(valueCopy)
  }

  const handleChildChecked = (e) => {
    const { value: itemValue, checked } = e.target
    const newValue = checked
      ? [...items, itemValue]
      : items.filter(v => v !== itemValue)

    if (newValue.length > 0 && !parentValue.includes('Vulnerability')) {
      parentField.onChange(parentField.value.concat('Vulnerability'))
    } else if (newValue.length === 0 && parentValue.includes('Vulnerability')) {
      const index = parentValue.indexOf('Vulnerability')
      if (index > -1) {
        const valueCopy = [...new Set(parentValue)]
        valueCopy.splice(index, 1)
        parentField.onChange(valueCopy)
      }
    }

    // send data to react hook form
    field.onChange(newValue)
  }

  return (
    <Box>
      <Box display="flex" alignItems="center" gap="spaceGapTiny">
        <Clickable
          variant="text"
          aria-label="Click to expand the nested checkboxes"
          onClick={() => setExpanded(!expanded)}
          color="colorActivePrimary"
          display="flex"
          role="button"
        >
          <Icon name={expanded ? 'chevronDown' : 'chevronRight'} />
        </Clickable>
        <Checkbox
          onChange={handleParentChecked}
          indeterminate={items.length > 0 && items.length < values.length}
          value='Vulnerability'
          checked={parentValue.includes('Vulnerability')}
        >
          Vulnerability
        </Checkbox>
      </Box>
      <>
      {
        expanded &&
        options.map(({ value, label, access }, i) => (
          <Box key={i} ml="40px" mt="spaceGapTiny">
             <Checkbox
                onChange={handleChildChecked}
                disabled={!access}
                value={value}
                checked={Array.isArray(items) && items.includes(value)}
              >
                {label}
              </Checkbox>
          </Box>
        ))
      }
      </>
    </Box>
  )
}
